// import React, { useState, useEffect } from "react";
// import Sidebar from "../../../Components/Sidebar";
// import TopNav from "../../../Components/TopNav";
// import {
//   getFaqListServ,
//   addFaqServ,
//   updateFaqServ,
//   deleteFaqServ,
// } from "../../../services/faq.service";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import NoRecordFound from "../../../Components/NoRecordFound";
// function UserFaq() {
//   const [list, setList] = useState([]);
//   const [statics, setStatics] = useState(null);
//   const [payload, setPayload] = useState({
//     searchKey: "",
//     category: "",
//     pageNo: 1,
//     pageCount: 10,
//     sortByField: "",
//   });
//   const [showSkelton, setShowSkelton] = useState(false);
//   const handleGetFaqFunc = async () => {
//     if (list.length === 0) {
//       setShowSkelton(true);
//     }
//     try {
//       let response = await getFaqListServ(payload);
//       setList(response?.data?.data);
//       setStatics(response?.data?.documentCount);
//     } catch (error) {}
//     setShowSkelton(false);
//   };
//   const staticsArr = [
//     {
//       title: "User Faqs",
//       count: statics?.userFaq,
//       bgColor: "#6777EF",
//     },
//   ];
//   useEffect(() => {
//     handleGetFaqFunc();
//   }, [payload]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [addFormData, setAddFormData] = useState({
//     question: "",
//     answer: "",
//     category: "user",
//   });
//   const handleAddFaqFunc = async () => {
//     setIsLoading(true);
//     try {
//       let response = await addFaqServ(addFormData);
//       if (response?.data?.statusCode == "200") {
//         toast.success(response?.data?.message);
//         setAddFormData({
//           question: "",
//           answer: "",
//           category: "",
//         });
//         handleGetFaqFunc();
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message
//           ? error?.response?.data?.message
//           : "Internal Server Error"
//       );
//     }
//     setIsLoading(false);
//   };
//   const handleDeleteFaqFunc = async (id) => {
//     const confirmed = window.confirm(
//       "Are you sure you want to delete this Faq?"
//     );
//     if (confirmed) {
//       try {
//         let response = await deleteFaqServ(id);
//         if (response?.data?.statusCode == "200") {
//           toast?.success(response?.data?.message);
//           handleGetFaqFunc();
//         }
//       } catch (error) {
//         toast.error(
//           error?.response?.data?.message
//             ? error?.response?.data?.message
//             : "Internal Server Error"
//         );
//       }
//     }
//   };
//   const [editFormData, setEditFormData] = useState({
//     question: "",
//     answer: "",
//     category: "",
//     _id: "",
//   });
//   const handleUpdateFaqFunc = async () => {
//     setIsLoading(true); 
//     try {
//       let response = await updateFaqServ(editFormData);
//       if (response?.data?.statusCode == "200") {
//         toast.success(response?.data?.message);
//         setEditFormData({
//           question:"",
//           answer:"",
//           category:"",
//           _id: "",
//         });
//         handleGetFaqFunc();
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message
//           ? error?.response?.data?.message
//           : "Internal Server Error"
//       );
//     }
//     setIsLoading(false);
//   };
//   const renderCategory = (category) => {
//     if (category == "user") {
//       return (
//         <button
//           className="badge"
//           style={{ height: "30px", background: "#6777EF", border:"none" }}
//         >
//           User
//         </button>
//       );
//     }
//     if (category == "driver") {
//       return (
//         <button
//           className="badge"
//           style={{ height: "30px", background: "#63ED7A", border:"none"}}
//         >
//           Driver
//         </button>
//       );
//     }
//     if (category == "vendor") {
//       return (
//         <button
//           className="badge"
//           style={{ height: "30px", background: "#FFA426", border:"none" }}
//         >
//           Vendor
//         </button>
//       );
//     }
//   };
//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="System Support" selectedItem="FAQs" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           >
//             {staticsArr?.map((v, i) => {
//               return (
//                 <div className="col-md-4 col-12 ">
//                   <div className="topCard shadow-sm py-4 px-3 rounded mb-3">
//                     <div className="d-flex align-items-center ">
//                       <div
//                         className="p-2 shadow rounded"
//                         style={{ background: v?.bgColor }}
//                       >
//                         <img src="https://cdn-icons-png.flaticon.com/128/666/666120.png" />
//                       </div>
//                       <div className="ms-3">
//                         <h6>{v?.title}</h6>
//                         <h2 className="text-secondary">{v?.count}</h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           <div className="row m-0 p-0 d-flex align-items-center my-4 topActionForm">
//             <div className="col-lg-2 mb-2 col-md-12 col-12">
//               <h3 className="mb-0 text-bold text-secondary">FAQs</h3>
//             </div>
//             <div className="col-lg-4 mb-2 col-md-12 col-12">
//               <div>
//                 <input
//                   className="form-control borderRadius24"
//                   placeholder="Search"
//                   onChange={(e) =>
//                     setPayload({ ...payload, searchKey: e.target.value })
//                   }
//                 />
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2  col-md-6 col-12">
//               <div>
//                 <select
//                   className="form-control borderRadius24"
//                   onChange={(e) =>
//                     setPayload({ ...payload, category: e.target.value })
//                   }
//                 >
//                   <option value="">Select Category</option>
//                   <option value="user">User</option>
//                 </select>
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2 col-md-6 col-12">
//               <div>
//                 <button
//                   className="btn btn-primary w-100 borderRadius24"
//                   style={{ background: "#6777EF" }}
//                   onClick={() => setAddFormData({ ...addFormData, show: true })}
//                 >
//                   Add Faq
//                 </button>
//               </div>
//             </div>
//           </div>
//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <table className="table">
//                   <tbody>
//                     <tr style={{ background: "#F3F3F3", color: "#000" }}>
//                       <th
//                         className="text-center py-3"
//                         style={{ borderRadius: "30px 0px 0px 30px" }}
//                       >
//                         Sr. No
//                       </th>
//                       <th className="text-center py-3">Question</th>
//                       <th className="text-center py-3">Answer</th>
//                       <th className="text-center py-3">Category</th>
//                       <th
//                         className="text-center py-3 "
//                         style={{ borderRadius: "0px 30px 30px 0px" }}
//                       >
//                         Action
//                       </th>
//                     </tr>
//                     <div className="py-2"></div>
//                     {showSkelton
//                       ? [1, 2, 3, 4, 5, 6, 7, 8, 9]?.map((v, i) => {
//                           return (
//                             <>
//                               <tr key={i}>
//                                 <td className="text-center">
//                                   <Skeleton width={50} height={50} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton
//                                     width={50}
//                                     height={50}
//                                     borderRadius={25}
//                                   />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>

//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                               </tr>
//                               <div className="py-2"></div>
//                             </>
//                           );
//                         })
//                       : list?.map((v, i) => {
//                           return (
//                             <>
//                               <tr>
//                                 <td className="text-center">{i + 1}</td>

//                                 <td className="font-weight-600 text-center">
//                                   {v?.question}
//                                 </td>
//                                 <td className="font-weight-600 text-center">
//                                   {v?.answer}
//                                 </td>
//                                 <td className="text-center">
//                                   {renderCategory(v?.category)}
//                                 </td>

//                                 <td className="text-center">
//                                   <a
//                                     onClick={() => {
//                                       setEditFormData({
//                                         question:v?.question,
//                                         answer:v?.answer,
//                                         category:v?.category,
//                                         _id: v?._id,
//                                       });
//                                     }}
//                                     className="btn btn-info mx-2 text-light shadow-sm"
//                                   >
//                                     Edit
//                                   </a>
//                                   <a
//                                     onClick={() =>
//                                         handleDeleteFaqFunc(v?._id)
//                                     }
//                                     className="btn btn-warning mx-2 text-light shadow-sm"
//                                   >
//                                     Delete
//                                   </a>
//                                 </td>
//                               </tr>
//                               <div className="py-2"></div>
//                             </>
//                           );
//                         })}
//                   </tbody>
//                 </table>
//                 {list.length == 0 && !showSkelton && <NoRecordFound />}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {addFormData?.show && (
//         <div
//           className="modal fade show d-flex align-items-center  justify-content-center "
//           tabIndex="-1"
//         >
//           <div className="modal-dialog">
//             <div
//               className="modal-content"
//               style={{
//                 borderRadius: "16px",
//                 background: "#f7f7f5",
//                 width: "364px",
//               }}
//             >
//               <div className="d-flex justify-content-end pt-4 pb-0 px-4">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
//                   style={{ height: "20px" }}
//                   onClick={() =>
//                     setAddFormData({
//                       question: "",
//                       answer: "",
//                       category: "",
//                       show: false,
//                     })
//                   }
//                 />
//               </div>

//               <div className="modal-body">
//                 <div
//                   style={{
//                     wordWrap: "break-word",
//                     whiteSpace: "pre-wrap",
//                   }}
//                   className="d-flex justify-content-center w-100"
//                 >
//                   <div className="w-100 px-2">
//                     <h5 className="mb-4">Add FAQ</h5>

//                     <label className="mt-3">Question</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...addFormData,
//                           question: e.target.value,
//                         })
//                       }
//                     />
//                     <label className="mt-3">Answer</label>
//                     <textarea
//                       className="form-control"
//                       type="text"
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...addFormData,
//                           answer: e.target.value,
//                         })
//                       }
//                     />
//                     <label className="mt-3">Category</label>
//                     <select
//                       className="form-control"
//                       value={addFormData.category || "user"}
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...addFormData,
//                           category: e.target.value,
//                         })
//                       }
//                     >
//                       <option value="">Select Status</option>
//                       <option value="user">User</option>
//                     </select>
//                     {addFormData?.question &&
//                     addFormData?.answer &&
//                     addFormData?.category ? (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         onClick={!isLoading && handleAddFaqFunc}
//                       >
//                         {isLoading ? "Saving..." : "Submit"}
//                       </button>
//                     ) : (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         style={{ opacity: "0.5" }}
//                       >
//                         Submit
//                       </button>
//                     )}
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-center"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {addFormData?.show && <div className="modal-backdrop fade show"></div>}
//       {editFormData?._id && (
//         <div
//           className="modal fade show d-flex align-items-center  justify-content-center "
//           tabIndex="-1"
//         >
//           <div className="modal-dialog">
//             <div
//               className="modal-content"
//               style={{
//                 borderRadius: "16px",
//                 background: "#f7f7f5",
//                 width: "364px",
//               }}
//             >
//               <div className="d-flex justify-content-end pt-4 pb-0 px-4">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
//                   style={{ height: "20px" }}
//                   onClick={() =>
//                     setEditFormData({
//                       question:"",
//                       answer:"",
//                       category:"",
//                       _id: "",
//                     })
//                   }
//                 />
//               </div>

//               <div className="modal-body">
//                 <div
//                   style={{
//                     wordWrap: "break-word",
//                     whiteSpace: "pre-wrap",
//                   }}
//                   className="d-flex justify-content-center w-100"
//                 >
//                   <div className="w-100 px-2">
//                     <h5 className="mb-4">Update Faq</h5>
                    
                    
//                     <label className="mt-3">Question</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           question: e.target.value,
//                         })
//                       }
//                       value={editFormData?.question}
//                     />
//                     <label className="mt-3">Answer</label>
//                     <textarea
//                       className="form-control"
//                       type="text"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           answer: e.target.value,
//                         })
//                       }
//                       value={editFormData?.answer}
//                     />
//                   <label className="mt-3">Category</label>
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...editFormData,
//                           category: e.target.value,
//                         })
//                       }
//                       value={editFormData?.category}
//                     >
//                       <option value="">Select Status</option>
//                       <option value="user">User</option>
//                     </select>
//                     {editFormData?.question && editFormData?.answer && editFormData?.category ? (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         onClick={!isLoading && handleUpdateFaqFunc}
//                       >
//                         {isLoading ? "Saving..." : "Submit"}
//                       </button>
//                     ) : (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         style={{ opacity: "0.5" }}
//                       >
//                         Submit
//                       </button>
//                     )}
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-center"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {editFormData?._id && <div className="modal-backdrop fade show"></div>}
//     </div>
//   );
// }

// export default UserFaq;


import React, { useState, useEffect } from "react";
import Sidebar from "../../../Components/Sidebar";
import TopNav from "../../../Components/TopNav";
import {
  getFaqListServ,
  addFaqServ,
  updateFaqServ,
  deleteFaqServ,
} from "../../../services/faq.service";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NoRecordFound from "../../../Components/NoRecordFound";

/* ─── Scoped Styles ─────────────────────────────────── */
const styles = `
  .faq-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'Segoe UI', sans-serif;
  }

  /* stats */
  .faq-stat-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 14px;
    margin-bottom: 20px;
    max-width: 320px;
  }

  .faq-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 16px 18px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    gap: 13px;
  }

  .faq-stat-icon {
    width: 46px;
    height: 46px;
    border-radius: 12px;
    background: #fdf2f1;
    color: #a60808;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 21px;
    flex-shrink: 0;
  }

  .faq-stat-value {
    font-size: 28px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
  }

  .faq-stat-label {
    font-size: 13px;
    color: #aaa;
    margin-top: 4px;
  }

  /* toolbar */
  .faq-toolbar {
    background: #fff;
    border-radius: 14px;
    padding: 16px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 18px;
  }

  .faq-toolbar-title {
    font-size: 19px;
    font-weight: 700;
    color: #1c0a0a;
  }

  .faq-toolbar-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .faq-input,
  .faq-select {
    height: 42px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    background: #f9f9f9;
    padding: 0 14px;
    font-size: 14px;
    color: #555;
    outline: none;
  }

  .faq-input {
    width: 250px;
  }

  .faq-input:focus,
  .faq-select:focus {
    border-color: #f0c0b8;
  }

  .faq-btn {
    height: 42px;
    padding: 0 18px;
    border-radius: 10px;
    border: none;
    background: #a60808;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 7px;
    cursor: pointer;
    transition: 0.2s;
  }

  .faq-btn:hover {
    background: #a93226;
  }

  /* table */
  .faq-table-wrap {
    background: #fff;
    border-radius: 14px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }

  .faq-table-scroll {
    overflow-x: auto;
  }

  .faq-table {
    width: 100%;
    border-collapse: collapse;
  }

  .faq-table thead tr {
    background: #fdf2f1;
  }

  .faq-table th {
    padding: 15px 18px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
  }

  .faq-table td {
    padding: 16px 18px;
    border-top: 1px solid #f7f5f5;
    vertical-align: top;
    font-size: 14px;
    color: #444;
  }

  .faq-table tbody tr:hover td {
    background: #fdfafa;
  }

  .faq-question {
    font-weight: 600;
    color: #222;
    min-width: 240px;
  }

  .faq-answer {
    color: #666;
    line-height: 1.6;
    min-width: 280px;
  }

  .faq-category {
    display: inline-flex;
    align-items: center;
    padding: 6px 14px;
    border-radius: 30px;
    background: #fdf2f1;
    color: #a60808;
    font-size: 13px;
    font-weight: 600;
  }

  .faq-action-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .faq-edit-btn,
  .faq-delete-btn {
    height: 34px;
    padding: 0 14px;
    border-radius: 9px;
    border: 1px solid;
    background: #fff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: 0.18s;
  }

  .faq-edit-btn {
    border-color: #cfe2ff;
    color: #185fa5;
  }

  .faq-edit-btn:hover {
    background: #e6f1fb;
  }

  .faq-delete-btn {
    border-color: #fcc;
    color: #a60808;
  }

  .faq-delete-btn:hover {
    background: #fdf2f1;
  }

  /* modal */
  .faq-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }

  .faq-modal {
    width: 100%;
    max-width: 520px;
    background: #fff;
    border-radius: 18px;
    overflow: hidden;
    animation: fadeIn 0.2s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  .faq-modal-header {
    padding: 20px 22px;
    border-bottom: 1px solid #f4f4f4;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .faq-modal-title {
    font-size: 19px;
    font-weight: 700;
    color: #1c0a0a;
  }

  .faq-close {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: none;
    background: #fdf2f1;
    color: #a60808;
    cursor: pointer;
    font-size: 18px;
  }

  .faq-modal-body {
    padding: 22px;
  }

  .faq-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #444;
  }

  .faq-field {
    margin-bottom: 18px;
  }

  .faq-textarea,
  .faq-modal-input,
  .faq-modal-select {
    width: 100%;
    border: 1px solid #f0eded;
    background: #fafafa;
    border-radius: 12px;
    padding: 12px 14px;
    outline: none;
    font-size: 14px;
    color: #444;
  }

  .faq-textarea {
    resize: none;
    min-height: 120px;
  }

  .faq-modal-input:focus,
  .faq-textarea:focus,
  .faq-modal-select:focus {
    border-color: #f0c0b8;
  }

  .faq-submit-btn {
    width: 100%;
    height: 46px;
    border: none;
    border-radius: 12px;
    background: #a60808;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s;
  }

  .faq-submit-btn:hover {
    background: #a93226;
  }

  .faq-submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    .faq-page {
      padding: 18px;
    }

    .faq-toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .faq-toolbar-right {
      width: 100%;
      flex-direction: column;
    }

    .faq-input,
    .faq-select,
    .faq-btn {
      width: 100%;
    }
  }
`;

function UserFaq() {
  const [list, setList] = useState([]);
  const [statics, setStatics] = useState(null);
  const [showSkelton, setShowSkelton] = useState(false);

  const [payload, setPayload] = useState({
    searchKey: "",
    category: "",
    pageNo: 1,
    pageCount: 10,
    sortByField: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const [addFormData, setAddFormData] = useState({
    question: "",
    answer: "",
    category: "user",
    show: false,
  });

  const [editFormData, setEditFormData] = useState({
    question: "",
    answer: "",
    category: "",
    _id: "",
  });

  const handleGetFaqFunc = async () => {
    if (list.length === 0) {
      setShowSkelton(true);
    }

    try {
      const response = await getFaqListServ(payload);
      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);
    } catch (error) {}

    setShowSkelton(false);
  };

  useEffect(() => {
    handleGetFaqFunc();
  }, [payload]);

  const handleAddFaqFunc = async () => {
    setIsLoading(true);

    try {
      let response = await addFaqServ(addFormData);

      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);

        setAddFormData({
          question: "",
          answer: "",
          category: "user",
          show: false,
        });

        handleGetFaqFunc();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Internal Server Error"
      );
    }

    setIsLoading(false);
  };

  const handleDeleteFaqFunc = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this FAQ?"
    );

    if (confirmed) {
      try {
        let response = await deleteFaqServ(id);

        if (response?.data?.statusCode == "200") {
          toast.success(response?.data?.message);
          handleGetFaqFunc();
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Internal Server Error"
        );
      }
    }
  };

  const handleUpdateFaqFunc = async () => {
    setIsLoading(true);

    try {
      let response = await updateFaqServ(editFormData);

      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);

        setEditFormData({
          question: "",
          answer: "",
          category: "",
          _id: "",
        });

        handleGetFaqFunc();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Internal Server Error"
      );
    }

    setIsLoading(false);
  };

  return (
    <div className="bodyContainer">
      <style>{styles}</style>

      <Sidebar selectedMenu="System Support" selectedItem="FAQs" />

      <div className="mainContainer">
        <TopNav pageTitle="User FAQs" pagePath="Home / Support / FAQs" />

        <div className="faq-page">

          {/* Stats */}
          <div className="faq-stat-grid">
            <div className="faq-stat-card">
              <div className="faq-stat-icon">
                <i className="ti ti-help" />
              </div>

              <div>
                <div className="faq-stat-value">
                  {statics?.userFaq || 0}
                </div>
                <div className="faq-stat-label">Total User FAQs</div>
              </div>
            </div>
          </div>

          {/* Toolbar */}
          <div className="faq-toolbar">
            <div className="faq-toolbar-title">Frequently Asked Questions</div>

            <div className="faq-toolbar-right">
              <input
                className="faq-input"
                placeholder="Search question..."
                onChange={(e) =>
                  setPayload({
                    ...payload,
                    searchKey: e.target.value,
                  })
                }
              />

              <select
                className="faq-select"
                onChange={(e) =>
                  setPayload({
                    ...payload,
                    category: e.target.value,
                  })
                }
              >
                <option value="">All Categories</option>
                <option value="user">User</option>
              </select>

              <button
                className="faq-btn"
                onClick={() =>
                  setAddFormData({
                    ...addFormData,
                    show: true,
                  })
                }
              >
                <i className="ti ti-plus" />
                Add FAQ
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="faq-table-wrap">
            <div className="faq-table-scroll">
              <table className="faq-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Question</th>
                    <th>Answer</th>
                    <th>Category</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {showSkelton ? (
                    [...Array(6)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(5)].map((__, j) => (
                          <td key={j}>
                            <Skeleton height={20} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td colSpan="5" style={{ padding: "50px" }}>
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list?.map((v, i) => (
                      <tr key={v?._id}>
                        <td>
                          {(payload.pageNo - 1) * payload.pageCount + i + 1}
                        </td>

                        <td>
                          <div className="faq-question">
                            {v?.question}
                          </div>
                        </td>

                        <td>
                          <div className="faq-answer">
                            {v?.answer}
                          </div>
                        </td>

                        <td>
                          <span className="faq-category">
                            User
                          </span>
                        </td>

                        <td>
                          <div className="faq-action-wrap">
                            <button
                              className="faq-edit-btn"
                              onClick={() => {
                                setEditFormData({
                                  question: v?.question,
                                  answer: v?.answer,
                                  category: v?.category,
                                  _id: v?._id,
                                });
                              }}
                            >
                              <i className="ti ti-edit" />
                              Edit
                            </button>

                            <button
                              className="faq-delete-btn"
                              onClick={() =>
                                handleDeleteFaqFunc(v?._id)
                              }
                            >
                              <i className="ti ti-trash" />
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Add Modal */}
      {addFormData?.show && (
        <div className="faq-modal-overlay">
          <div className="faq-modal">

            <div className="faq-modal-header">
              <div className="faq-modal-title">Add FAQ</div>

              <button
                className="faq-close"
                onClick={() =>
                  setAddFormData({
                    question: "",
                    answer: "",
                    category: "user",
                    show: false,
                  })
                }
              >
                ×
              </button>
            </div>

            <div className="faq-modal-body">

              <div className="faq-field">
                <label className="faq-label">Question</label>

                <input
                  className="faq-modal-input"
                  type="text"
                  placeholder="Enter question"
                  onChange={(e) =>
                    setAddFormData({
                      ...addFormData,
                      question: e.target.value,
                    })
                  }
                />
              </div>

              <div className="faq-field">
                <label className="faq-label">Answer</label>

                <textarea
                  className="faq-textarea"
                  placeholder="Enter answer"
                  onChange={(e) =>
                    setAddFormData({
                      ...addFormData,
                      answer: e.target.value,
                    })
                  }
                />
              </div>

              <div className="faq-field">
                <label className="faq-label">Category</label>

                <select
                  className="faq-modal-select"
                  value={addFormData?.category}
                  onChange={(e) =>
                    setAddFormData({
                      ...addFormData,
                      category: e.target.value,
                    })
                  }
                >
                  <option value="user">User</option>
                </select>
              </div>

              <button
                className="faq-submit-btn"
                disabled={
                  !addFormData?.question ||
                  !addFormData?.answer ||
                  isLoading
                }
                onClick={handleAddFaqFunc}
              >
                {isLoading ? "Saving..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editFormData?._id && (
        <div className="faq-modal-overlay">
          <div className="faq-modal">

            <div className="faq-modal-header">
              <div className="faq-modal-title">Update FAQ</div>

              <button
                className="faq-close"
                onClick={() =>
                  setEditFormData({
                    question: "",
                    answer: "",
                    category: "",
                    _id: "",
                  })
                }
              >
                ×
              </button>
            </div>

            <div className="faq-modal-body">

              <div className="faq-field">
                <label className="faq-label">Question</label>

                <input
                  className="faq-modal-input"
                  type="text"
                  value={editFormData?.question}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      question: e.target.value,
                    })
                  }
                />
              </div>

              <div className="faq-field">
                <label className="faq-label">Answer</label>

                <textarea
                  className="faq-textarea"
                  value={editFormData?.answer}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      answer: e.target.value,
                    })
                  }
                />
              </div>

              <div className="faq-field">
                <label className="faq-label">Category</label>

                <select
                  className="faq-modal-select"
                  value={editFormData?.category}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      category: e.target.value,
                    })
                  }
                >
                  <option value="user">User</option>
                </select>
              </div>

              <button
                className="faq-submit-btn"
                disabled={
                  !editFormData?.question ||
                  !editFormData?.answer ||
                  isLoading
                }
                onClick={handleUpdateFaqFunc}
              >
                {isLoading ? "Saving..." : "Update FAQ"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserFaq;